import { YesNo } from "../../../../../../src/api/fmr1";

export const generateRowId = () => crypto.randomUUID();

export type RowWithSortOrder = { sort_order?: number | null };
export type RowWithSno = { row_id: string; sno?: number | null };

export const YES_NO_OPTIONS = Object.values(YesNo).map((v) => ({ name: v, value: v }));

const isFiniteNumber = (v: unknown): v is number => typeof v === "number" && Number.isFinite(v);

export function getInsertedSortOrder(prev: number | null | undefined, next: number | null | undefined): number {
  const p = isFiniteNumber(prev) ? prev : null;
  const n = isFiniteNumber(next) ? next : null;

  if (p == null && n == null) return 1;
  if (p == null) return (n as number) - 1;
  if (n == null) return p + 1;

  const mid = (p + n) / 2;
  if (mid === p || mid === n) return p + (n - p) / 3;
  return Number(mid.toFixed(12));
}

export function sortRowsBySortOrder<T extends RowWithSortOrder>(rows: T[]): T[] {
  const withIdx = rows.map((r, idx) => ({
    r,
    idx,
    key: isFiniteNumber(r.sort_order) ? r.sort_order : idx + 1,
  }));

  withIdx.sort((a, b) => (a.key - b.key) || (a.idx - b.idx));
  return withIdx.map((x) => x.r);
}

export function getInsertedSno(prev?: RowWithSno) {
  return (prev?.sno ?? 0) + 1;
}

export function getSnoUpdates<T extends RowWithSno>(rows: T[], startIndex: number, delta: number) {
  const start = Math.max(0, startIndex);
  return rows.slice(start).map((r) => ({
    id: r.row_id,
    newSno: (r.sno ?? 0) + delta,
  }));
}
